import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider){

	$stateProvider.state('main.panel.scheduler', {
		url: '/scheduler',
		template: template,
		controller: controller,
		controllerAs: 'vm'

	});

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/scheduler.component/routes.js
 **/